import common from './common';
import home from './home';
import services from './services';
import experience from './experience';
import projects from './projects';
import technologies from './technologies';
import contact from './contact';
import labs from './labs';
import admin from './admin';
import tunnel from './tunnel';
import blog from './blog';
import activities from './activities';
import cases from './cases';
import auth from './auth';
import legal from './legal';

const frTranslation = {
  ...common,
  ...home,
  services,
  experiences: experience,
  ...projects,
  ...technologies,
  contact,
  labs,
  admin,
  tunnel,
  ...blog,
  ...activities,
  ...cases,
  ...auth,
  ...legal
};

export default frTranslation;
